"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var complete_account_modal_html_1 = __importDefault(require("./complete-account-modal.html"));
var complete_account_modal_controller_1 = __importDefault(require("./complete-account-modal.controller"));
var AdminStudentsVerificationController = /** @class */ (function () {
    function AdminStudentsVerificationController($scope, $state, UsersModel, FlashService, filterFilter, DriveSessionTypesModel, $uibModal, $q, $window) {
        var _this = this;
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$q = $q;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.filterFilter = filterFilter;
        this.loadingTypes = false;
        this.minutes = [];
        this.loading = true;
        this.deletingUser = false;
        this.$window = $window;
        for (var i = 0; i < 60; i++) {
            if (i % 5 === 0) {
                this.minutes.push({ name: i, value: i });
            }
        }
        this.hours = [];
        for (var i = 0; i < 60; i++) {
            this.hours.push({ name: i, value: i });
        }
        this.formdata = {
            student: null,
            accredit_data: [],
        };
        this.processStudents = this.processStudents.bind(this);
        DriveSessionTypesModel.get().then(function (response) {
            _this.sessiontypes = response.sessionTypes.filter(function (type) { return type.status === "Active"; });
            _this.sessiontypes.forEach(function (type) {
                _this.formdata.accredit_data.push({
                    type: type,
                    hours_purchased: 0,
                    minutes_purchased: 0,
                });
            });
            _this.accreditData = [].concat(_this.formdata.accredit_data);
            // Show all of the possible drive session types
            _this.defaultAccreditData = [].concat(_this.formdata.accredit_data);
        });
        this.UsersModel.getStudents({ filter: "verify", page_by: 20 }).then(function (response) {
            _this.totalItems = response.students.total;
            _this.students = response.students.data.filter(_this.processStudents);
            _this.loading = false;
        });
    }
    AdminStudentsVerificationController.prototype.deleteUser = function (id) {
        var _this = this;
        var confirmDelete = this.$window.confirm("Are you sure you want to delete this user? ALL THE ACCOUNTS DATA WILL BE LOST. YOU CANNOT UNDO THIS.");
        if (confirmDelete === true) {
            this.deletingUser = true;
            this.UsersModel.deleteStudent({ id: id })
                .then(function (response) {
                _this.deletingUser = false;
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.students = _this.students.filter(function (user) {
                    return user.id !== id;
                });
            })
                .catch(function (Error) {
                _this.deletingUser = false;
            });
        }
    };
    AdminStudentsVerificationController.prototype.completeStudentAccount = function (student) {
        var _this = this;
        var getStudent = this.UsersModel.getStudentByID(student.id);
        var getPickupLocations = this.UsersModel.getPickupLocations(student.id);
        this.$q.all([getStudent, getPickupLocations]).then(function (responses) {
            _this.pickuplocations = responses[1].pickuplocations;
            // Address is already an object from the backend
            responses[0].pickuplocations = responses[1].pickuplocations;
            var modalInstance = _this.$uibModal.open({
                animation: true,
                template: complete_account_modal_html_1.default,
                controller: complete_account_modal_controller_1.default,
                controllerAs: "vm",
                size: "lg",
                resolve: {
                    student: responses[0],
                },
            });
            modalInstance.result.then(function (data) { }, function () {
                //$log.info('Modal dismissed at: ' + new Date());
            });
        });
    };
    AdminStudentsVerificationController.prototype.pageChanged = function () {
        var _this = this;
        var params = {
            page: this.currentPage,
            filter: "verify",
            page_by: 20,
        };
        if (this.studentName) {
            params.name = this.studentName;
        }
        this.UsersModel.getStudents(params).then(function (response) {
            _this.totalItems = response.students.total;
            _this.students = response.students.data.filter(_this.processStudents);
        });
    };
    AdminStudentsVerificationController.prototype.search = function () {
        var _this = this;
        this.UsersModel.getStudents(__assign(__assign({}, (this.studentName ? { name: this.studentName } : {})), { page: this.currentPage, page_by: 20, filter: "verify" })).then(function (response) {
            _this.totalItems = response.students.total;
            _this.students = response.students.data.filter(_this.processStudents);
        });
    };
    AdminStudentsVerificationController.prototype.verifyStudent = function () {
        var _this = this;
        if (this.submitting) {
            return;
        }
        this.submitting = true;
        var formdata = Object.assign({}, this.formdata);
        formdata.accredit_data = formdata.accredit_data.map(function (data) {
            data.time_purchased_in_minutes =
                data.hours_purchased * 60 + data.minutes_purchased;
            return data;
        });
        this.UsersModel.verifyStudent(formdata)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.students = _this.students.filter(function (student) {
                return student.id !== formdata.student.id;
            });
            _this.resetAccreditDataForm();
            // Open modal with student info in it
            if (response.student.setup_complete === false) {
                _this.completeStudentAccount(formdata.student);
            }
            _this.formdata.student = null;
            _this.submitting = false;
        })
            .catch(function (response) {
            _this.submitting = false;
        });
    };
    AdminStudentsVerificationController.prototype.resetAccreditDataForm = function () {
        this.formdata.accredit_data = []
            .concat(this.defaultAccreditData)
            .map(function (accredit_data) {
            accredit_data.hours_purchased = 0;
            accredit_data.minutes_purchased = 0;
            return accredit_data;
        });
    };
    AdminStudentsVerificationController.prototype.processStudents = function (student) {
        student.usermeta.hours_purchased = "2";
        student.usermeta.minutes_purchased = "0";
        if (typeof student.default_school_location[0] !== "undefined") {
            student.location = student.default_school_location[0].name;
            if (typeof student.default_sector[0] !== "undefined") {
                student.zone = student.default_sector[0].name;
            }
        }
        if (student.orders.length === 1) {
            student.orders[0].lineitems = student.orders[0].lineitems.map(function (lineitem) {
                return lineitem;
            });
        }
        return student;
    };
    AdminStudentsVerificationController.prototype.selectStudent = function (student) {
        var _this = this;
        this.loadingTypes = true;
        this.order = null;
        this.formdata.accredit_data = [].concat(this.defaultAccreditData);
        this.UsersModel.getPurchasedTime(student.id).then(function (response) {
            if (response.data.length > 0) {
                _this.formdata.accredit_data.concat(response.data.filter(function (data) {
                    return ("auto_verify_on_purchase" in data.type &&
                        data.type.auto_verify_on_purchase === false);
                }));
            }
            else {
                _this.formdata.accredit_data = []
                    .concat(_this.defaultAccreditData)
                    .map(function (accredit_data) {
                    accredit_data.hours_purchased = 0;
                    accredit_data.minutes_purchased = 0;
                    return accredit_data;
                });
            }
            if (_this.formdata.accredit_data.length === 0) {
                _this.formdata.accredit_data = []
                    .concat(_this.accreditData)
                    .map(function (accredit_data) {
                    accredit_data.hours_purchased = 0;
                    accredit_data.minutes_purchased = 0;
                    return accredit_data;
                });
            }
            _this.loadingTypes = false;
        });
        this.formdata.student = student;
    };
    AdminStudentsVerificationController.prototype.selectOrder = function (order) {
        this.order = order;
    };
    return AdminStudentsVerificationController;
}());
AdminStudentsVerificationController.$inject = [
    "$scope",
    "$state",
    "UsersModel",
    "FlashService",
    "filterFilter",
    "DriveSessionTypesModel",
    "$uibModal",
    "$q",
    "$window",
];
exports.default = AdminStudentsVerificationController;
